/* source-option-formatter.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./source-option-formatter.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import { IconTile } from '@atlaskit/icon';
import Blog24Icon from '@atlaskit/icon-object/glyph/blog/24';
import Page24Icon from '@atlaskit/icon-object/glyph/page/24';
import EditorCloseIcon from '@atlaskit/icon/core/migration/cross--editor-close';
import PlusSquareIcon from '@atlaskit/icon/core/plus-square';
import Image from '@atlaskit/image';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { messages } from './messages';
var styles = {
  sourceOptionWrapper: "_zulputpp _1e0c1txw _4cvr1h6o _1bah1yb4 _vchhusvi _80omtlke _irr319i6 _d0altlke",
  sourceOptionTitle: "_11c82smr _syazi7uo",
  sourceOptionMetadata: "_11c81o8v _1e0c1txw _syaz1rpy",
  sourceOptionMetatadataSeparator: "_18u01b66 _2hwx1b66",
  sourceImageContainer: "_4t3i1tcg _1bsb1tcg"
};
var SourceSpaceImage = function SourceSpaceImage(_ref) {
  var source = _ref.source;
  return source.iconUrl ? /*#__PURE__*/React.createElement(Box, {
    xcss: styles.sourceImageContainer
  }, /*#__PURE__*/React.createElement(Image, {
    src: source.iconUrl,
    alt: ""
  })) : /*#__PURE__*/React.createElement(IconTile, {
    icon: PlusSquareIcon,
    label: "",
    appearance: "blueBold",
    shape: "square",
    size: "24"
  });
};
export var SourceOption = function SourceOption(_ref2) {
  var source = _ref2.source,
    canClear = _ref2.canClear,
    onClickSource = _ref2.onClickSource,
    onRemoveSource = _ref2.onRemoveSource;
  var _useIntl = useIntl(),
    formatDate = _useIntl.formatDate,
    formatMessage = _useIntl.formatMessage;
  var sourceIcon = /*#__PURE__*/React.createElement(Page24Icon, {
    label: ""
  });
  if (source.type === 'space') {
    sourceIcon = /*#__PURE__*/React.createElement(SourceSpaceImage, {
      source: source
    });
  } else if (source.type === 'blogpost') {
    sourceIcon = /*#__PURE__*/React.createElement(Blog24Icon, {
      label: ""
    });
  }
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.sourceOptionWrapper,
    onClick: onClickSource
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: "space.150"
  }, sourceIcon, /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.sourceOptionTitle
  }, source.title), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.sourceOptionMetadata
  }, /*#__PURE__*/React.createElement(Text, null, source.container), source.lastModified && /*#__PURE__*/React.createElement(Box, {
    xcss: styles.sourceOptionMetatadataSeparator
  }, "\u2022"), source.lastModified && /*#__PURE__*/React.createElement(Text, null, "".concat(formatMessage(messages.edit_definition_source_option_metadata_updated_text), " ").concat(formatDate(source.lastModified, {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  })))))), canClear ? /*#__PURE__*/React.createElement(IconButton, {
    testId: "remove-source-".concat(source.id),
    appearance: "subtle",
    onClick: onRemoveSource,
    label: "remove-source-option-button",
    icon: EditorCloseIcon
  }) : /*#__PURE__*/React.createElement("div", null));
};